var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { of, pipe } from 'rxjs';
import { StateService } from './state.service';
import { OcapiService } from '../ocapi/ocapi.service';
import { LoginService } from '../login/login.service';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { CustomerProductHoldingUtil } from '../../model/customer-product-holding/customer-product-holding.util';
import { UserUtil } from '../../model/customer/customer.util';
import { OcapiSynchronousService } from '../ocapi/ocapi.synchronous.service';
import { EntertainmentPackService } from '../entertainment-pack/entertainment-pack-service';
import { TvShopEntertainmentPackGroupFactory } from '../../factories/tv-shop-entertainment-pack-group.factory';
import { TvShopEntertainmentPackGroups } from '../../constants/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.constants';
import { ErrorMessageConstants } from '../../shared/error-message-constants';
import * as i0 from "@angular/core";
import * as i1 from "../ocapi/ocapi.service";
import * as i2 from "../login/login.service";
import * as i3 from "../entertainment-pack/entertainment-pack-service";
import * as i4 from "../ocapi/ocapi.synchronous.service";
import * as i5 from "@angular/router";
var initialState = {
    loader: {
        title: undefined,
        description: 'Opening TV Shop ...',
        openingTvShop: true,
        isLoading: true,
        loaderCount: 1
    },
    hasError: false,
    customer: undefined,
    dtvIdentifier: undefined,
    tvShopEntertainmentPacks: [],
    tvShopStreamingServices: [],
    tvShopEntertainmentPackGroups: [],
    basket: {
        installationAddress: undefined,
        locationId: undefined,
        selectedTvShopEntertainmentPack: undefined,
        selectStreamingServiceOption: undefined
    },
    isStreamingBundleOrder: false,
    isStreamingServiceOrder: false,
    isLoggedIn: false,
    isInitiated: false,
    isOrderProcessPending: false,
    isTrailerPlaying: false,
    customerProductHolding: undefined,
    salesOrder: undefined
};
var TvShopStateService = /** @class */ (function (_super) {
    __extends(TvShopStateService, _super);
    function TvShopStateService(ocapiService, loginService, entertainmentPackService, ocapiSynchronousService, router) {
        var _this = _super.call(this, initialState) || this;
        _this.ocapiService = ocapiService;
        _this.loginService = loginService;
        _this.entertainmentPackService = entertainmentPackService;
        _this.ocapiSynchronousService = ocapiSynchronousService;
        _this.router = router;
        _this.loader$ = _this.select(function (state) { return state.loader; });
        _this.hasError$ = _this.select(function (state) { return state.hasError; });
        _this.isInitiated$ = _this.select(function (state) { return state.isInitiated; });
        _this.isOrderProcessPending$ = _this.select(function (state) { return state.isOrderProcessPending; });
        _this.isTrailerPlaying$ = _this.select(function (state) { return state.isTrailerPlaying; });
        _this.salesOrder$ = _this.select(function (state) { return state.salesOrder; });
        return _this;
    }
    TvShopStateService.prototype.activateStreamingService = function () {
        var _this = this;
        var basket = this.state.basket;
        return this.ocapiSynchronousService.activateStreamingService(basket).pipe(tap(function (salesOrder) {
            if (_this.selectSnapshot(function (state) { return state.isStreamingBundleOrder; })) {
                _this.handleBundleResponse(basket, salesOrder);
            }
            if (_this.selectSnapshot(function (state) { return state.isStreamingServiceOrder; })) {
                _this.handleStandaloneResponse(basket, salesOrder);
            }
        }), map(function (salesOrder) {
            return {
                id: salesOrder.id,
                success: true
            };
        }), catchError(function (error) {
            if (error.status === 403 && error.error && error.error.code === ErrorMessageConstants.OCAPI_ERR_ODSO123) {
                return of({
                    errorCode: ErrorMessageConstants.OCAPI_ERR_ODSO123,
                    errorMessage: ErrorMessageConstants.STREAMING_BUNDLE_WAITING_ACTIVATION
                });
            }
            else {
                return of({
                    errorCode: ErrorMessageConstants.ERROR_FETCHING_STREAMING_SERVICES,
                    errorMessage: ErrorMessageConstants.STREAMING_BUNDLE_ACTIVATION_ERROR
                });
            }
        }));
    };
    TvShopStateService.prototype.handleBundleResponse = function (basket, salesOrder) {
        this.setUnsubscribedForOtherPacksinGroup(basket);
        if (basket.selectedTvShopEntertainmentPack) {
            var streamingBundle = this.state.tvShopStreamingServices.find(function (streamingService) {
                return streamingService.omapiId === basket.selectedTvShopEntertainmentPack.omapiId;
            });
            if (streamingBundle) {
                this.setGroupPackToSubscribed(basket);
                streamingBundle.subscribed = true;
            }
        }
        if (basket.selectStreamingServiceOption) {
            var streamingBundleAddon = this.state.tvShopStreamingServices.find(function (streamingService) {
                return streamingService.omapiId === basket.selectStreamingServiceOption.omapiid;
            });
            if (streamingBundleAddon) {
                streamingBundleAddon.subscribed = true;
            }
        }
        this.setState({ salesOrder: salesOrder });
    };
    TvShopStateService.prototype.handleStandaloneResponse = function (basket, salesOrder) {
        if (basket.selectedTvShopEntertainmentPack) {
            var entertainmentPack = this.state.tvShopStreamingServices.find(function (streamingService) {
                return streamingService.omapiId === basket.selectedTvShopEntertainmentPack.omapiId;
            });
            if (entertainmentPack) {
                entertainmentPack.subscribed = true;
            }
        }
        this.setState({ salesOrder: salesOrder });
    };
    TvShopStateService.prototype.setGroupPackToSubscribed = function (basket) {
        var _this = this;
        this.state.tvShopEntertainmentPackGroups.map(function (packGroup) {
            if (packGroup.childPacks.some(function (packs) { return packs.omapiId === basket.selectedTvShopEntertainmentPack.omapiId; })) {
                packGroup.subscribed = true;
                _this.state.basket.selectedTvShopEntertainmentPack = packGroup;
            }
            return packGroup;
        });
    };
    TvShopStateService.prototype.setUnsubscribedForOtherPacksinGroup = function (basket) {
        var _this = this;
        if (basket.selectedTvShopEntertainmentPack.isStreamingStandaloneProduct) {
            var streamingBundleGroup = this.getPackGroupFromOmapiId(basket);
            streamingBundleGroup.childPacks.forEach(function (pack) {
                _this.state.tvShopStreamingServices.map(function (packs) {
                    if (pack.omapiId && packs.omapiId && pack.omapiId !== basket.selectedTvShopEntertainmentPack.omapiId) {
                        packs.subscribed = false;
                    }
                    return packs;
                });
            });
        }
    };
    TvShopStateService.prototype.getPackGroupFromOmapiId = function (basket) {
        return this.state.tvShopEntertainmentPackGroups.find(function (packGroup) { return packGroup.childPacks.some(function (packs) {
            return packs.omapiId === basket.selectedTvShopEntertainmentPack.omapiId;
        }); });
    };
    TvShopStateService.prototype.setIsStreamingBundleOrder = function (isStreamingBundleOrder) {
        this.setState({ isStreamingBundleOrder: isStreamingBundleOrder });
    };
    TvShopStateService.prototype.setIsStreamingServiceOrder = function (isStreamingServiceOrder) {
        this.setState({ isStreamingServiceOrder: isStreamingServiceOrder });
    };
    TvShopStateService.prototype.setTvShopEntertainmentPacks = function (tvShopEntertainmentPacks) {
        this.setState({ tvShopEntertainmentPacks: tvShopEntertainmentPacks });
    };
    TvShopStateService.prototype.setSelectedTvShopEntertainmentPack = function (tvShopEntertainmentPack) {
        this.setState({
            basket: Object.assign({}, this.state.basket, { selectedTvShopEntertainmentPack: tvShopEntertainmentPack })
        });
    };
    TvShopStateService.prototype.setTvShopEntertainmentPack = function (tvShopEntertainmentPack) {
        if (tvShopEntertainmentPack.omapiId === OmapiIdsUtils.NETFLIX_PREMIUM_ID) {
            var netflixStandardTvEntertainmentPack = this.state.tvShopStreamingServices.find(function (service) { return service.omapiId === OmapiIdsUtils.NETFLIX_STANDARD_ID; });
            this.setState({
                basket: Object.assign({}, this.state.basket, {
                    selectedTvShopEntertainmentPack: netflixStandardTvEntertainmentPack,
                    selectStreamingServiceOption: tvShopEntertainmentPack
                })
            });
        }
        else {
            this.setState({
                basket: Object.assign({}, this.state.basket, {
                    selectedTvShopEntertainmentPack: tvShopEntertainmentPack,
                    selectStreamingServiceOption: null
                })
            });
        }
    };
    TvShopStateService.prototype.setSelectedStreamingBundleOption = function (streamingOption) {
        this.setState({
            basket: Object.assign({}, this.state.basket, { selectStreamingServiceOption: streamingOption })
        });
    };
    TvShopStateService.prototype.setLoader = function (loader) {
        this.setState({ loader: loader });
    };
    TvShopStateService.prototype.setHasError = function (hasError) {
        this.setState({ hasError: hasError });
    };
    TvShopStateService.prototype.setIsInitiated = function (isInitiated) {
        this.setState({ isInitiated: isInitiated });
    };
    TvShopStateService.prototype.setIsOrderProcessPending = function (isOrderProcessPending) {
        this.setState({ isOrderProcessPending: isOrderProcessPending });
    };
    TvShopStateService.prototype.setIsTrailerPlaying = function (isTrailerPlaying) {
        this.setState({ isTrailerPlaying: isTrailerPlaying });
    };
    TvShopStateService.prototype.handleError = function (message, error) {
        this.setHasError(true);
        console.error(message, error);
    };
    TvShopStateService.prototype.setLoading = function (isLoading) {
        var partial = {
            isLoading: this.state.loader.loaderCount > 1,
            loaderCount: this.state.loader.loaderCount - 1
        };
        if (isLoading) {
            partial = {
                isLoading: true,
                loaderCount: this.state.loader.loaderCount + 1
            };
        }
        var loaderState = Object.assign({}, this.state.loader, partial);
        this.setState({ loader: loaderState });
    };
    TvShopStateService.prototype.login = function () {
        var _this = this;
        return this.loginService.login().pipe(tap(function (dtvIdentifier) {
            _this.setState({
                dtvIdentifier: dtvIdentifier,
                customer: {
                    currentUserType: OmapiIdsUtils.currentUserType,
                    isEligibleForStreamingBundles: false
                }
            });
        }), mergeMap(function () {
            return _this.ocapiService.getCustomerProductHolding();
        }), map(function (rawCustomerProductHolding) {
            var dtvIdentifier = _this.state.dtvIdentifier;
            var customerProductHolding = rawCustomerProductHolding && rawCustomerProductHolding['customerproductholding'];
            var hasDTVAndInternet = CustomerProductHoldingUtil.hasDTVAndInternet(customerProductHolding);
            var isDwnCustomer = UserUtil.isDwnCustomer(_this.state.customer.currentUserType);
            var isSoho = UserUtil.isSohoCustomer(OmapiIdsUtils.currentDarwinUserType);
            var installationAddress = _this.ocapiService.getAddressFromCustomerProductHolding(rawCustomerProductHolding, dtvIdentifier);
            var locationId = _this.ocapiService.getLocationIdFromCustomerProductHolding(rawCustomerProductHolding, dtvIdentifier);
            _this.setState({
                isLoggedIn: true,
                customerProductHolding: customerProductHolding,
                customer: {
                    currentUserType: _this.state.customer.currentUserType,
                    isEligibleForStreamingBundles: isDwnCustomer && hasDTVAndInternet && !isSoho,
                    isSohoCustomer: isSoho
                },
                basket: Object.assign({}, _this.state.basket, {
                    installationAddress: installationAddress,
                    locationId: locationId
                })
            });
            return true;
        }), catchError(function (error) {
            _this.setLoading(false);
            _this.handleError(error);
            return of(false);
        }));
    };
    TvShopStateService.prototype.initialise = function (routes) {
        var _this = this;
        var dtvIdentifier = this.state.dtvIdentifier;
        var isSoho = this.state.customer.isSohoCustomer;
        return this.entertainmentPackService.getEntertainmentPacksAndStreamingServices(dtvIdentifier, isSoho).pipe(tap(function (result) {
            var customerProductHolding = _this.state.customerProductHolding;
            var enrichedStreamingServices = _this.entertainmentPackService.enrichStreamingServicesWithOmapi(result.streamingServicesOptions, customerProductHolding);
            _this.setState({ tvShopStreamingServices: enrichedStreamingServices });
            return result;
        }), mergeMap(function (result) {
            return _this.entertainmentPackService.enrichTvEntertainmentPacksWithOmapi(result.tvShopEntertainmentPacks);
        }), map(function (tvShopEntertainmentPacks) {
            _this.router.resetConfig(routes);
            _this.setState({ tvShopEntertainmentPacks: tvShopEntertainmentPacks });
            return true;
        }), this.handleProductsWaitingForActivation(), catchError(function (error) {
            _this.setLoading(false);
            _this.handleError(error);
            return of(false);
        }));
    };
    TvShopStateService.prototype.handleProductsWaitingForActivation = function () {
        var _this = this;
        var customerType = this.state.customer.currentUserType;
        if (UserUtil.isDwnCustomer(customerType)) {
            return pipe(mergeMap(function () {
                var locationId = _this.state.basket.locationId;
                return _this.ocapiSynchronousService.getProductsWaitingToGetActivatedForLocation(locationId);
            }), map(function (products) {
                _this.state.tvShopStreamingServices.forEach(function (streamingService) {
                    var streamingServiceWaitingToBeActivated = products.some(function (product) {
                        return (product.omapiId === streamingService.omapiId ||
                            product.options.some(function (option) { return option.omapiId === streamingService.omapiId; }));
                    });
                    if (streamingServiceWaitingToBeActivated) {
                        streamingService.subscribed = true;
                    }
                });
                return true;
            }), tap(function () {
                var tvShopEntertainmentPacks = _this.state.tvShopEntertainmentPacks;
                var tvShopStreamingServices = _this.state.tvShopStreamingServices;
                if (!_this.state.customer.isSohoCustomer && tvShopStreamingServices.length) {
                    _this.setState({
                        tvShopEntertainmentPackGroups: TvShopEntertainmentPackGroupFactory.build(TvShopEntertainmentPackGroups, tvShopEntertainmentPacks.concat(tvShopStreamingServices))
                    });
                }
                _this.setState({
                    isInitiated: true
                });
            }));
        }
        return pipe(tap(function () {
            _this.setState({ isInitiated: true });
        }));
    };
    TvShopStateService.prototype.logState = function () {
        console.log('state', this.state);
    };
    TvShopStateService.ngInjectableDef = i0.defineInjectable({ factory: function TvShopStateService_Factory() { return new TvShopStateService(i0.inject(i1.OcapiService), i0.inject(i2.LoginService), i0.inject(i3.EntertainmentPackService), i0.inject(i4.OcapiSynchronousService), i0.inject(i5.Router)); }, token: TvShopStateService, providedIn: "root" });
    return TvShopStateService;
}(StateService));
export { TvShopStateService };
